import * as React from 'react';
import { EvenOddInput, FloatInput, IntInput } from './number-input';
import { Parameter } from 'shapediver-types';
import { ParameterType, ShapeDiverValue } from '../../shape-diver';
import { ReactElement } from 'react';
import SelectInput from './select-input';
import CheckboxInput from './checkbox-input';
import StringInput from './string-input';
import ColorInput from './color-input';
import FileInput from './file-input';

type ParameterDefinition = Parameter.ParameterDefinition;

function inputFactory(
  value: ShapeDiverValue,
  label: string,
  definition: ParameterDefinition,
  onChange: (newValue: ShapeDiverValue) => void
): ReactElement {
  const { type } = definition;

  switch (type) {
    case ParameterType.INT:
      return (
        <IntInput
          initialValue={Number(value)}
          definition={definition}
          onChange={onChange}
        />
      );
    case ParameterType.FLOAT:
      return (
        <FloatInput
          initialValue={Number(value)}
          definition={definition}
          onChange={onChange}
        />
      );
    case ParameterType.EVEN:
    case ParameterType.ODD:
      return (
        <EvenOddInput
          initialValue={Number(value)}
          definition={definition}
          onChange={onChange}
        />
      );
    case ParameterType.STRINGLIST:
      return (
        <SelectInput
          initialValue={Number(value)}
          definition={definition}
          onChange={onChange}
        />
      );
    case ParameterType.BOOL:
      return (
        <CheckboxInput
          initialValue={Boolean(value)}
          definition={definition}
          onChange={onChange}
        />
      );
    case ParameterType.STRING:
      return (
        <StringInput
          initialValue={String(value)}
          definition={definition}
          onChange={onChange}
        />
      );
    case ParameterType.COLOR:
      return (
        <ColorInput
          initialValue={String(value)}
          definition={definition}
          onChange={onChange}
        />
      );
    case ParameterType.FILE:
      return (
        <FileInput definition={definition} onChange={onChange} label={label} />
      );
    default:
      console.error('Unsupported ShapeDiver type: ' + type);
      return <div>Input: {type}</div>;
  }
}

export default inputFactory;
